import { fromJS } from 'immutable'
import { openNavMenu, closeNavMenu, toggleNavMenu } from '../navigation/actions.js'

let defaultState = fromJS({
  isMenuOpen: false
})

export default function navigation (state = defaultState, action) {
  state = fromJS(state)

  switch (action.type) {
    case openNavMenu.type:
      return state.set('isMenuOpen', true)

    case closeNavMenu.type:
      return state.set('isMenuOpen', false)

    case toggleNavMenu.type:
      return state.set('isMenuOpen', !state.get('isMenuOpen'))

    default:
      return state
  }
}

export const selectIsMenuOpen = state => state.navigation.get('isMenuOpen')



// WEBPACK FOOTER //
// ./client/src/navigation/reducer.js